import React from 'react';
import css from './Progress.module.scss';


/**
 * @class
 *
 * The "progress steps" component that indicates which "steps" have been completed and which remain. (Compare this to a "checkout steps" component).
 *
 * This component is purely presentational, as there is no use interactivity.
 *
 * @prop stages {array}: An array of strings, where each string represents the displayed text for the stage. The array should be ordered; that is,
 * the first step should be the first element in array, the second step should be the second element in array, etc.
 * @prop currentStageIndex {number}: The index of the current stage with respect to the list of `stages`. Index is 0-based. This number is used to
 * determine which steps within `stages` has already been completed, what the current stage is, and which stages are left.
 *
 * @example
 *  // state:
 *  state = {
 *      stages: [
 *          'foo',
 *          'bar',
 *          'fizz',
 *          'buzz'
 *      ],
 *      currentStageIndex: 0
 *  };
 *
 *  // markup:
 *  <Progress currentStageIndex={this.state.currentStageIndex} stages={this.state.stages} />
 */
const Progress = (props) => {
    const progressItemCssObj = (index) => {
        if (index < props.currentStageIndex) {
            return `${css.Progress__Item} ${css.Progress__ItemCompleted}`;
        } else if (index === props.currentStageIndex) {
            return `${css.Progress__Item} ${css.Progress__ItemActive}`;
        } else {
            return css.Progress__Item;
        }
    };

    return (
        <nav className={css.Progress}>
            {
                props.stages.map((stage, index) => {
                    return (
                        <div key={index} className={progressItemCssObj(index)} style={ {width: `calc(100% / ${props.stages.length})`} }>
                            <div className={css.Progress__ItemContent}>
                                <span className={css.Progress__ItemIcon}>{index+1}</span>
                                { index > 0 ? <span className={css.Progress__ItemLine}></span> : null }
                                <span className={css.Progress__ItemText}>{stage}</span>
                            </div>
                        </div>
                    );
                })
            }
        </nav>
    );
};

export default Progress;
